<app-data-table [columns]="columns" [data]="clientsTable()" [filters]="filters" [totalRecords]="totalRecords()"
  [cardTemplate]="card" (add)="onAdd()" (edit)="onEdit($event)" (pageChange)="onPage($event)"
  (removeSelected)="onRemoveSelected($event)" (search)="onSearch($event)" />

<ng-template #card let-client>
  <div class="surface-card shadow-2 p-3 border-round h-full flex flex-column">
    <div class="flex align-items-center justify-content-between mb-3">
      <div class="flex align-items-center">
        <div
          class="flex align-items-center justify-content-center bg-blue-100 text-blue-500 border-circle w-3rem h-3rem font-bold text-xl mr-2">
          {{ client.name.charAt(0).toUpperCase() }}
        </div>
        <div>
          <div class="font-bold text-900">{{ client.name }}</div>
          <div class="text-500 text-sm">{{ client.name_contact ? 'Contacto: ' + client.name_contact : 'Sin contacto' }}</div>
          <div class="text-500 text-sm"><i class="pi pi-building mr-1" *ngIf="client.city"></i>{{ client.city || 'Sin ciudad' }}</div>
        </div>
      </div>
      <p-button icon="pi pi-ellipsis-v" [text]="true" [rounded]="true" severity="secondary"
        (onClick)="onEdit(client)"></p-button>
    </div>

    <div class="flex flex-column gap-2 mt-auto">
      <div class="flex align-items-center gap-2 text-700">
        <i class="pi pi-envelope text-500"></i>
        <span class="white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ client.email }}</span>
      </div>
      <div class="flex align-items-center gap-2 text-700">
        <i class="pi pi-phone text-500"></i>
        <span>{{ client.phone }}</span>
      </div>
    </div>

    <div class="flex gap-2 mt-3 pt-3 border-top-1 surface-border">
      <a pButton class="flex-1 p-button-outlined p-button-sm justify-content-center no-underline"
        href="mailto:{{client.email}}">
        <i class="pi pi-envelope mr-2"></i> Email
      </a>
      <a pButton class="flex-1 p-button-outlined p-button-sm justify-content-center no-underline"
        href="tel:{{client.phone}}">
        <i class="pi pi-phone mr-2"></i> Llamar
      </a>
    </div>
  </div>
</ng-template>

<app-add-client [(visible)]="dialogVisible" (save)="onSave($event)" />